import { render, staticRenderFns } from "./ClientMiniCard.vue?vue&type=template&id=6a502def&lang=pug&"
import script from "./ClientMiniCard.vue?vue&type=script&lang=js&"
export * from "./ClientMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports